import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import iustiaLogoDark from '../../../assets/images/logos/iustia-logo.svg';
import iustiaLogoWhite from '../../../assets/images/logos/iustia-logo-white.svg';
import SideMenu from '../SideMenu';
import { useUI } from '../../../redux/hooks';
import { useAuthMode } from '../../../redux/hooks';

const AuthNavBar = () => {
  const { isSideMenuOpen, openSideMenu } = useUI();
  const { isLawyer } = useAuthMode();

  return (
    <motion.header
      className="shadow-sm px-8 py-4"
      initial={false}
      animate={{ backgroundColor: isLawyer ? '#132A56' : '#fbfcf8' }}
      transition={{ duration: 0.5, ease: 'easeInOut' }}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center">
            <img
              src={isLawyer ? iustiaLogoWhite : iustiaLogoDark}
              alt="Iustia Logo"
              className="h-6 w-auto"
            />
          </Link>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={openSideMenu}
            className="flex flex-col justify-center w-12 h-12 bg-transparent border-none cursor-pointer p-0"
            aria-label="Menu"
          >
            <div className="flex flex-col gap-1.5 py-2 px-2">
              <motion.span
                className="block w-7 h-0.5 rounded-2xl"
                initial={false}
                animate={{
                  backgroundColor: isSideMenuOpen ? '#ffffff' : isLawyer ? '#ffffff' : '#1f2937',
                }}
                transition={{ duration: 0.5, ease: 'easeInOut' }}
              ></motion.span>
              <motion.span
                className="block w-5 h-0.5 rounded-2xl ml-2"
                initial={false}
                animate={{
                  backgroundColor: isSideMenuOpen ? '#ffffff' : isLawyer ? '#ffffff' : '#1f2937',
                }}
                transition={{ duration: 0.5, ease: 'easeInOut' }}
              ></motion.span>
            </div>
          </button>
        </div>
      </div>

      {/* Side Menu */}
      <SideMenu />
    </motion.header>
  );
};

export default AuthNavBar;
